import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import CustomModal from "../basics/interface/CustomModal"
import Loader from "../basics/Loader"
import { COLORS } from "../../utilities/Constants"

// Version V2 (CustomModal) de AtelierModalQuantites — affiche les articles
// manquants en quantité avant une transition d'état. BLOQUANT (décision
// Jordan 02.10) : une pièce utilisée doit être en stock, plus de débit
// partiel — le back refuse aussi la transition (StockInsuffisantError).
const AtelierModalQuantitesV2 = ({
	fetchAtelierQuantites,
	atelierQuantites,
	closeModal,
}) => {
	const { loading, error } = fetchAtelierQuantites
	const centered = {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: 10,
		textAlign: "center",
		padding: "8px 0",
	}
	if (loading) {
		return (
			<CustomModal
				title={"Vérification des quantités disponibles…"}
				showFooter={false}
				showCloseButton={false}
				onClose={closeModal}
			>
				<Loader size={28} padding={24} />
			</CustomModal>
		)
	}
	if (error) {
		return (
			<CustomModal
				title={"Erreur"}
				onClose={closeModal}
				showCloseButton={false}
				buttons={[
					{
						title: "Fermer",
						styleName: "primary",
						onClick: closeModal,
					},
				]}
			>
				<div style={centered}>
					<FontAwesomeIcon
						icon={faTimesCircle}
						size="2x"
						style={{ color: COLORS.danger }}
					/>
					<div>Une erreur est apparue, un rapport a été envoyé.</div>
				</div>
			</CustomModal>
		)
	}
	if (atelierQuantites.length > 0) {
		return (
			<CustomModal
				title={"Stock insuffisant"}
				subtitle={
					"Les articles suivants ne sont pas en stock en quantité suffisante :"
				}
				onClose={closeModal}
				showCloseButton={false}
				buttons={[
					{
						title: "Fermer",
						styleName: "primary",
						onClick: closeModal,
					},
				]}
			>
				<div style={centered}>
					{atelierQuantites.map((el) => (
						<div key={el}>{el}</div>
					))}
					<div
						style={{
							marginTop: 8,
							fontSize: 12,
							color: COLORS.textMuted,
						}}
					>
						Une pièce utilisée doit être en stock pour terminer les
						travaux : saisir la réception de commande dans
						l'inventaire (Inventaire → Commandes), puis réessayer.
					</div>
				</div>
			</CustomModal>
		)
	}
	return null
}

export default AtelierModalQuantitesV2
